"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseClient = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class BaseClient {
  constructor(props) {
    this.headers = new Headers(_objectSpread(_objectSpread({
      'Content-Type': 'application/json',
      'Accept': 'application/json; charset=utf-8'
    }, props.accessToken && {
      Authorization: `Bearer ${props.accessToken}`
    }), props.sessionId && {
      'x-session-id': props.sessionId
    }));
    this.channelIds = props.channelIds;
    this.cancelled = false;
  }
  /**
   * Mark the client as cancelled.
   */


  cancel() {
    this.cancelled = true;
  }
  /**
   * Return whether this client has been cancelled.
   */


  isCancelled() {
    return this.cancelled;
  }

}

exports.BaseClient = BaseClient;